import { useNavigate, useParams } from 'react-router-dom';
import { useResetPasswordMutation } from '../api/authApi';
import { useState } from 'react';
import { toast } from 'react-toastify';
import { Input } from '../../../components/Input';
import { Button } from '../../../components/Button';

export const PasswordReset = () => {
  const navigate = useNavigate();
  const [reset, { isLoading }] = useResetPasswordMutation();
  const [newPassword, setNewPassword] = useState({
    password: '',
    confirmPassword: ''
  });
  const { token, uidb64 } = useParams();
  const onReset = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!token || !uidb64) return;
    if (!newPassword.password || !newPassword.confirmPassword) {
      toast.error('Please fill all the fields');
      return;
    }
    if (newPassword.password !== newPassword.confirmPassword) {
      return toast.error('Passwords do not match');
    }
    try {
      const { password } = newPassword;
      reset({ newPassword: password, uid: uidb64, token }).unwrap();
      toast.success('Password reset successfully');
      setNewPassword({ password: '', confirmPassword: '' });
      navigate('/login');
    } catch (err) {
      return err;
    }
  };
  return (
    <div className="max-w-md mx-auto text-center mt-20">
      <h1 className="font-bold mb-8 text-2xl">Reset password</h1>
      <form className="flex flex-col items-center gap-4" onSubmit={onReset}>
        <Input
          label="Password"
          placeholder="password"
          type="password"
          value={newPassword.password}
          onChange={(e) => {
            setNewPassword((prev) => ({ ...prev, password: e.target.value }));
          }}
        />
        <Input
          label="Confirm password"
          placeholder="confirm password"
          type="password"
          value={newPassword.confirmPassword}
          onChange={(e) => {
            setNewPassword((prev) => ({ ...prev, confirmPassword: e.target.value }));
          }}
        />
        <Button type="submit" isLoading={isLoading} className="w-full mt-4">
          Submit new password
        </Button>
      </form>
    </div>
  );
};
